/* Meta Pixel — standard official snippet, wrapped in helper functions. */

const PIXEL_ID = '796624063387305'

const DEFAULT_PRODUCT = {
  content_name: 'El Código Maestro',
  value: 27.0,
  currency: 'USD',
}

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: unknown
    }
    _fbq?: unknown
  }
}

let initialized = false

function loadPixelScript() {
  if (typeof window === 'undefined') return
  if (window.fbq) return /* eslint-disable */
  ;(function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */
}

export function initPixel() {
  if (initialized || typeof window === 'undefined') return
  try {
    loadPixelScript()
    window.fbq?.('init', PIXEL_ID)
    initialized = true
  } catch (err) {
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackPageView() {
  if (!initialized) initPixel()
  try {
    window.fbq?.('track', 'PageView')
  } catch (err) {
    console.warn('Meta Pixel PageView failed:', err)
  }
}

export function trackAddToCart(data?: {
  content_name?: string
  value?: number
  currency?: string
}) {
  if (!initialized) initPixel()
  try {
    window.fbq?.('track', 'AddToCart', data ?? DEFAULT_PRODUCT)
  } catch (err) {
    console.warn('Meta Pixel AddToCart failed:', err)
  }
}

export function trackPurchase(data?: {
  content_name?: string
  value?: number
  currency?: string
}) {
  if (!initialized) initPixel()
  try {
    window.fbq?.('track', 'Purchase', data ?? DEFAULT_PRODUCT)
  } catch (err) {
    console.warn('Meta Pixel Purchase failed:', err)
  }
}
